import React from 'react';
import { GenericFilterBadge, FilterBadgeDataItem } from './generic-filter-badge';
import { AdObjectiveBadgeProps } from './types';

const AdObjectiveBadges = React.forwardRef<HTMLDivElement, AdObjectiveBadgeProps>(
  ({ children: _children, className, data, onDismiss, ...props }, ref) => {
    const getDisplayText = (item: FilterBadgeDataItem) => item.name || '';

    const getTooltipValue = (data: FilterBadgeDataItem[]) => data.map((objective) => objective.name || '').join(', ');

    return (
      <GenericFilterBadge
        ref={ref}
        data={data}
        onDismiss={onDismiss}
        label="Objective"
        tooltipTitle="Ad Objective Filter"
        tooltipKey="Selected Objectives"
        ariaLabel="Ad objective filter"
        dismissAriaLabel="Remove ad objective filter"
        getDisplayText={getDisplayText}
        getTooltipValue={getTooltipValue}
        className={className}
        {...props}
      />
    );
  },
);

AdObjectiveBadges.displayName = 'AdObjectiveBadges';

export { AdObjectiveBadges };
